import { Theme, alpha } from '@mui/material';

export const iconButtonPillStyle = (theme: Theme) => ({
  color: theme.palette.text.secondary,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  transition: theme.transitions.create(['background-color', 'border-color', 'color', 'box-shadow']),
  '&:hover': {
    color: theme.palette.text.primary,
    borderColor: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.16),
    boxShadow: `0 0 12px ${alpha(theme.palette.primary.main, 0.35)}`,
  },
});
